import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { messengerIntegrationsQuery } from "modules/settings/lib/messenger/messengerIntegrationsQuery"
import { DataResponse, MessengerAuthorizeSchema, MessengerIntegrationsResponseData } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof MessengerIntegrationsResponseData>>

export function useCreateMessengerIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof MessengerAuthorizeSchema>) => {
      const response = await axios.post<Response>(`/integrations/messenger/authorize`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: messengerIntegrationsQuery().queryKey })
    },
  })
}
